import React from 'react';

export const StatusBadge = ({ isActive, activeText = 'Active', inactiveText = 'Inactive' }) => {
  return (
    <span className="mst-status-cell">
      <span className={`mst-status-dot ${isActive ? 'active' : 'inactive'}`} />
      <span style={{ color: isActive ? '#047857' : '#64748b' }}>
        {isActive ? activeText : inactiveText}
      </span>
    </span>
  );
};

export default StatusBadge;
